import { Builder } from '@builder.io/react'
import React from 'react'
import './faq-column.css'
import CdnImage from 'components/util/CdnImage'
// import CloudinaryImage from 'components/util/CloudinaryImage'
import { HeadingClass, HeadingType } from 'enums'
import { headingClassPropObj, headingTypePropObj } from '../common/heading'
import FAQ from '../faq'

interface Faq {
  question: string
  answer: string
}

interface Props {
  backgroundColor: string
  TextDescription: string
  TextDescriptionColor: string
  WholeFaqsBackgroundColor: string
  // cloudinaryImage: any
  builderImage: any
  imgAltText: string
  headingText: string
  headingTextColor: string
  faqQuestionColor: string
  faqAnswerColor: string
  headingType: HeadingType
  headingClass: HeadingClass
  faqs: Faq[]
  showArrow: boolean
}

const FaqColumn = ({
  backgroundColor,
  TextDescription,
  TextDescriptionColor,
  WholeFaqsBackgroundColor,
  // cloudinaryImage,
  builderImage,
  imgAltText = '',
  headingText,
  headingTextColor,
  faqQuestionColor,
  faqAnswerColor,
  headingType,
  headingClass,
  faqs,
  showArrow
}: Props) => {
  return (
    <div style={{ backgroundColor: backgroundColor || '#f9f5f1' }}>
      <div className="faq-column-container mx-auto grid max-w-7xl gap-8 py-5 px-0 sm:grid-cols-1 sm:px-2 sm:py-10 md:grid-cols-2 lg:px-4">
        <div className="faq-column-container-left">
          <CdnImage className="h-auto w-full" url={builderImage} alt={imgAltText} steps={[700, 600]} />
          {/* {builderImage ? (
            <CdnImage className="h-auto w-full" url={builderImage} alt={imgAltText} steps={[700, 600]} />
          ) : (
            <CloudinaryImage
              className="h-auto w-full"
              publicId={cloudinaryImage?.public_id}
              alt={imgAltText}
              steps={[700, 600]}
              autoFormat={false}
            />
          )} */}
          <div
            className="font-serif-regular break-words pt-3.5 font-normal"
            style={{ color: TextDescriptionColor || '#000000' }}
          >
            {TextDescription}
          </div>
        </div>
        <div className="faq-column-container-right">
          <div className="faq-column-container-right-faqs relative">
            {showArrow && (
              <img
                className="absolute z-40 hidden lg:block"
                style={{ top: '-1rem', left: '-0.5rem' }}
                src={'self-drawing-arrow-2.svg'}
                alt="Arrow 2"
              />
            )}
            {showArrow && (
              <span
                className="font-third absolute absolute z-40 hidden text-3xl lg:block"
                style={{ top: '-0.5rem', left: '8rem' }}
              >
                Alison's advice for common ailments
              </span>
            )}
            {
              <FAQ
                faqs={faqs}
                backgroundColor={WholeFaqsBackgroundColor}
                headingText={headingText}
                headingTextColor={headingTextColor}
                faqQuestionColor={faqQuestionColor}
                faqAnswerColor={faqAnswerColor}
                headingType={headingType}
                headingClass={headingClass}
                FaqsQuestionBackgroundColor={'#A6C7D1'}
                FaqsAnswerBackgroundColor={'#C0D1D6'}
                PlusMinusBackgroundColor={'#006685'}
                PlusMinusColor={'white'}
              />
            }
          </div>
        </div>
      </div>
    </div>
  )
}

export default FaqColumn

Builder.registerComponent(FaqColumn, {
  name: 'FaqColumn',
  inputs: [
    {
      name: 'backgroundColor',
      type: 'color',
      defaultValue: '#f9f5f1'
    },
    // {
    //   name: 'cloudinaryImage',
    //   type: 'cloudinaryImageEditor'
    // },
    {
      name: 'builderImage',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },
    {
      name: 'imgAltText',
      type: 'text',
      defaultValue: ''
    },
    {
      name: 'TextDescription',
      type: 'text',
      defaultValue:
        'nsj Lorem ipsum dolor sit, amet consectetur adipisicing elit. Nihil dicta maxime nisi, debitis amet quas recusandae consectetur et asperiores quos eaque illo eveniet consequatur hic officia consequuntur doloremque voluptate perferendis, iure vel necessitatibus tenetur incidunt. Odio unde ipsam quas similique praesentium, ea necessitatibus, sequi perferendis eius numquam consequuntur minima fuga.'
    },
    {
      name: 'TextDescriptionColor',
      type: 'color',
      defaultValue: 'black'
    },
    {
      name: 'WholeFaqsBackgroundColor',
      type: 'color',
      defaultValue: 'transparent'
    },
    {
      ...headingTypePropObj
    },
    {
      ...headingClassPropObj
    },
    {
      name: 'headingText',
      type: 'text',
      defaultValue: 'FAQs'
    },
    {
      name: 'headingTextColor',
      type: 'color',
      defaultValue: 'black'
    },
    {
      name: 'faqQuestionColor',
      type: 'color',
      defaultValue: 'white'
    },
    {
      name: 'faqAnswerColor',
      type: 'color',
      defaultValue: 'white'
    },
    {
      name: 'faqs',
      type: 'list',
      defaultValue: [{ question: 'Whats the best food that we can get?', answer: 'Dog food' }],
      subFields: [
        { name: 'question', type: 'string', defaultValue: 'Whats the best food that we can get?' },
        { name: 'answer', type: 'string', defaultValue: 'Dog food' }
      ]
    },
    {
      name: 'showArrow',
      type: 'boolean',
      defaultValue: false
    }
  ]
})
